import React from 'react';
import {PasswordInput} from '@practicegenius/pg-ui/src/base/Material/components/PasswordInput';
import {voidOp} from '@practicegenius/pg-util/src/TypescriptUtils';
import {PasswordStrengthCalculator} from './PasswordStrengthCalculator';
import {InlineError} from './InlineError';

/**
 * Password input for use when inputting a "new password"
 *  - Displays current password strength
 *  - Validates input (formState.errors)
 *  - Displays appropriate error messages (recommendation || displayError)
 *
 * See PasswordInput for inputting credentials to log in
 *
 * @deprecated - Prefer pg-ui version for new use-cases
 */
export function CreatePasswordInput(
  props: {
    name: string;
    validate?: (validationMessage?: string) => void;
    user?: Record<string, unknown>;
  } & React.ComponentProps<typeof PasswordInput>,
) {
  const {
    name,
    value,
    onChange,
    user,
    validate = voidOp,
    error,
    ...inputProps
  } = props;
  const strengthCalculator: React.Ref<PasswordStrengthCalculator> =
    React.useRef(null);

  const inlineError = error && (
    // @ts-ignore - TS thinks InlineError expects string | null, when it really excepts ?string, which is string | null | undefined
    <InlineError error={error} />
  );

  return (
    <>
      <PasswordInput
        {...inputProps}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={() => {
          value && validate(strengthCalculator.current?.validate(value));
        }}
        autoComplete="new-password"
      />
      <PasswordStrengthCalculator
        ref={strengthCalculator}
        user={user}
        password={value}
      />
      {inlineError}
    </>
  );
}
